import { createContext } from 'react';

const FootnoteContext = createContext({
  footnotes: {},
});

export default FootnoteContext;
